import { NgModule } from '@angular/core';
import { BaseUrlCdnPipe } from './base-url-cdn.pipe';
import { SafeTypePipe } from './safe-type.pipe';
import { CountryPipe } from './country.pipe';
import { CountryImagePipe } from './country-image.pipe';
import { CountryCodePhonePipe } from './country-code-phone.pipe';
import { MaskNumberAccountPipe } from './mask-number-account.pipe';
import { DocumentDescriptionPipe } from './document-description.pipe';

const pipes = [
    BaseUrlCdnPipe,
    SafeTypePipe,
    CountryPipe,
    CountryImagePipe,
    CountryCodePhonePipe,
    MaskNumberAccountPipe,
    DocumentDescriptionPipe
];

@NgModule({
    declarations: [ ...pipes ],
    exports: [ ...pipes ],
    providers: [
        ...pipes
    ]
})
export class RoblexPipesModule {
    //
}
